import { render, staticRenderFns } from "./TableStaff.vue?vue&type=template&id=00c4631a&scoped=true"
import script from "./TableStaff.vue?vue&type=script&lang=js"
export * from "./TableStaff.vue?vue&type=script&lang=js"
import style0 from "./TableStaff.vue?vue&type=style&index=0&id=00c4631a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4631a",
  null
  
)

export default component.exports